/**
 * Whether a plan is far enough along to estimate: at least one room with at
 * least one section of product (Wall&CeilingBoard or SlatWall) on any wall,
 * the ceiling, or a ceiling plane. Layout issues do not count against it.
 */

import { FloorPlan } from './floorPlan';
import { roomSurfaceList } from '../../types/sections';

export function hasFinishedSection(plan: FloorPlan): boolean {
  return plan.rooms.some((room) => roomSurfaceList(room.surfaces).some((s) => s.sections.length > 0));
}
